<app-video-background></app-video-background>
<app-pencarian [datesOnly]="true"></app-pencarian>
<app-pertanyaan></app-pertanyaan>
<app-featop></app-featop>
<app-popular></app-popular>
<app-featbc></app-featbc>
<app-blog-home></app-blog-home>
<app-smartch></app-smartch>
<app-review></app-review>
<app-review-b></app-review-b>
<app-footer></app-footer>